import ModalController from './modal_controller';

export default class extends ModalController {
  static targets = ['roleType', "container", "entry", "destroyField", "newPhones", "primaryField"];

  show(event) {
    super.show(event);

    this.stimulate(
      (event.target.dataset.showReflexClass || 'PersonReflex') + '#show_person_modal',
      event.currentTarget,
    );
  }

  changeRole(event) {
    if (this.hasRoleTypeTarget) {
      this.roleTypeTarget
    }
    let setting = JSON.parse(event.currentTarget.dataset.setting)

    if (setting[event.currentTarget.value] != null) {
      let form = event.srcElement.closest('form');
      setting = setting[event.currentTarget.value][0];
      Object.keys(setting).forEach(key => {
        if (key != 'id') {
          let input = form.querySelector("#installations_person_" + key);
          if (input != null) { // revisit for all type of inputs
            input.checked = setting[key];
          }
        }
      });

    } else {
      console.log("Missing setting for role " + event.currentTarget.value);
    }
  }


  submitPerson(event) {
    event.preventDefault();

    var target = event.currentTarget;
    var originalLabel = target.innerHTML;
    if (target.disabled === true) { return }
    target.disabled = true;
    target.innerHTML = event.currentTarget.dataset.stimulusDisableWith;

    this.stimulate(
      (event.target.dataset.submitReflexClass || 'PersonReflex') + '#' + (event.target.dataset.submitReflexAction || 'submit_person_modal'), event.target)
      .then(payload => {

        const html = payload.event.detail.html;
        const hasDuplicateConfirmation = html && html.includes('alert-warning');

        if (!hasDuplicateConfirmation) {
          this.closeModal();
          const success_event = new CustomEvent('save-indicator:success', { detail: payload });
          window.dispatchEvent(success_event);

          if (html) {
            let parser = new DOMParser();
            let element = parser.parseFromString(html, 'text/html');
            let redirectLink = element.querySelector('a#redirect_to');
            if (redirectLink != undefined) {
              window.location.replace(redirectLink.getAttribute('href'))
            }
          }
        }
      })
      .catch(payload => {
        const failed_event = new CustomEvent('save-indicator:failed', { detail: payload });
        let title = payload.element.closest('.modal-dialog').querySelector('.header h4');
        title.innerHTML = payload.event.detail.stimulusReflex.serverMessage.body;
        title.classList.toggle('error')
        window.dispatchEvent(failed_event);
      })
      .finally(() => {
        target.disabled = false;
        target.innerHTML = originalLabel;
      });
  }

   addPhone(event) {
    event.preventDefault();

    const newEntry = this.createPhoneEntry();
    this.containerTarget.insertAdjacentHTML('beforeend', newEntry);
  }

  removePhone(event) {
    event.preventDefault()

    const entry = event.target.closest('[data-target="person-modal.entry"]');
    const destroyFields = entry.querySelectorAll('[data-target="person-modal.destroyField"]')
    console.log('Found destroy fields:', destroyFields.length)
    destroyFields.forEach(field => {
    console.log('Field:', field.name, field.type, field.value)
  })
    const destroyField = entry.querySelector('[data-target="person-modal.destroyField"]');
      console.log('Destroy field found:', destroyField)
  console.log('Current value:', destroyField?.value)
  console.log('Field name:', destroyField?.name)

    if (destroyField) {
      destroyField.value = "1";
      console.log('New value:', destroyField.value)
      entry.classList.add('marked-for-deletion');
      entry.style.opacity = '0.5';
      entry.style.textDecoration = 'line-through';

      const removeLink = event.target;
      removeLink.textContent = '↺';
      removeLink.dataset.action = 'click->person-modal#undoRemove';
    } else {
      entry.remove()
    }
  }

  undoRemove(event) {
    event.preventDefault()

    const entry = event.target.closest('[data-target="person-modal.entry"]')
    const destroyField = entry.querySelector('[data-target="person-modal.destroyField"]')

    if (destroyField) {
      destroyField.value = "0";
      entry.classList.remove('marked-for-deletion');
      entry.style.opacity = '1';
      entry.style.textDecoration = 'none';

      const removeLink = event.target
      removeLink.textContent = '×'
      removeLink.dataset.action = 'click->person-modal#removePhone'
    }
  }

  static targets = ['roleType', "container", "newPhones", "entry", "destroyField", "primaryField"];

  createPhoneEntry() {
    const timestamp = new Date().getTime()

    return `
      <div class="phone-entry" data-target="person-modal.entry">
        <div class="phone-fields-row">
          <div class="phone-number-field">
            <label for="installations_person_person_attributes_phones_attributes_${timestamp}_number">${this.getLabel('number')}</label>
            <input type="text" name="installations_person[person_attributes][phones_attributes][${timestamp}][number]" id="installations_person_person_attributes_phones_attributes_${timestamp}_number" />
          </div>

          <div class="phone-type-field">
            <label for="installations_person_person_attributes_phones_attributes_${timestamp}_phone_type">${this.getLabel('phone_type')}</label>
            <select name="installations_person[person_attributes][phones_attributes][${timestamp}][phone_type]" id="installations_person_person_attributes_phones_attributes_${timestamp}_phone_type">
              ${this.getPhoneTypeOptions()}
            </select>
          </div>

          <div class="phone-use-case-field">
            <label for="installations_person_person_attributes_phones_attributes_${timestamp}_use_case">${this.getLabel('use_case')}</label>
            <select name="installations_person[person_attributes][phones_attributes][${timestamp}][use_case]" id="installations_person_person_attributes_phones_attributes_${timestamp}_use_case">
              ${this.getUseCaseOptions()}
            </select>
          </div>

          <div class="phone-primary-field">
            <label for="primary_phone_${timestamp}">${this.getLabel('primary')}</label>
            <input type="radio" name="primary_phone" value="${timestamp}" data-action="change->person-modal#setPrimaryPhone" data-phone-index="${timestamp}" />
            <input type="hidden" name="installations_person[person_attributes][phones_attributes][${timestamp}][primary]" value="0" data-target="person-modal.primaryField" />
          </div>

          <a href="#" class="remove-phone" data-action="click->person-modal#removePhone">×</a>
        </div>
      </div>
    `
  }

  setPrimaryPhone(event) {
    // Nastaví všechny hidden fieldy na 0
    this.primaryFieldTargets.forEach(field => {
      field.value = '0'
    })

    // Najde příslušný hidden field a nastaví ho na 1
    const entry = event.target.closest('[data-target="person-modal.entry"]')
    const primaryField = entry.querySelector('[data-target="person-modal.primaryField"]')
    if (primaryField) {
      primaryField.value = '1'
    }
  }

getLabel(field) {
  const fieldMap = {
    number: 'number',
    phone_type: 'phone-type',
    use_case: 'use-case',
    primary: 'primary'
  }

  const dataKey = `personModalLabel${fieldMap[field].split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('')}`
  return this.element.dataset[dataKey] || field
}


  getPhoneTypeOptions() {
    return `
      <option value="mobile">Mobil</option>
      <option value="landline">Pevná linka</option>
      <option value="fax">Fax</option>
      <option value="other">Jiné</option>
    `
  }

  getUseCaseOptions() {
    return `
      <option value="info">Info</option>
      <option value="technical">Technické</option>
      <option value="monitoring">Monitoring</option>
      <option value="business">Obchodní</option>
      <option value="marketing">Marketing</option>
      <option value="personal">Osobní</option>
      <option value="administrative">Administrativní</option>
      <option value="logistics">Logistika</option>
      <option value="emergency">Nouzové</option>
      <option value="other">Jiné</option>
    `
  }
}
